import React from "react";

interface DataErrorProps {
  message?: string;
}

const DataError: React.FC<DataErrorProps> = ({ message }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-[24px] text-center">
      <div className="mb-[16px] flex h-[64px] w-[64px] items-center justify-center rounded-full border-2 border-[rgba(255,77,79,0.3)] bg-[rgba(255,77,79,0.06)]">
        <span className="text-[28px]">!</span>
      </div>
      <p className="text-[18px] font-[700] leading-[25px] text-[#e4e4e7]">数据加载失败</p>
      {message && (
        <p className="mt-[8px] text-[14px] leading-[20px] text-[#71717a]">{message}</p>
      )}
      <button
        className="mt-[24px] min-h-[44px] rounded-lg border border-[rgba(255,255,255,0.08)] bg-[rgba(255,255,255,0.04)] px-[32px] text-[14px] text-[#e4e4e7] active:scale-[0.96]"
        onClick={() => window.location.reload()}
      >
        重试
      </button>
    </div>
  );
};

export default DataError;
